export default __webpack_public_path__ + "static/media/logo.dfc28d4b.gif";